import { defineMessages } from "react-intl";

import { Status } from "lib/build/forms/basic-health/patientCondition";

export const shortStatusMessages = defineMessages<Status>({
	[Status.NEW]: {
		id: "patient_status.short.new",
		defaultMessage: "ÚJ"
	},
	[Status.MEDICAL_EXAMINATION_IN_PROGRESS]: {
		id: "patient_status.short.medical_examination_in_progress",
		defaultMessage: "EIP"
	},
	[Status.DONE]: {
		id: "patient_status.short.done",
		defaultMessage: "D"
	},
	[Status.EXIT]: {
		id: "patient_status.short.exit",
		defaultMessage: "EX"
	}
});

export const longStatusMessages = defineMessages<Status>({
	[Status.NEW]: {
		id: "patient_status.long.new",
		defaultMessage: "Új"
	},
	[Status.MEDICAL_EXAMINATION_IN_PROGRESS]: {
		id: "patient_status.long.medical_examination_in_progress",
		defaultMessage: "Kivizsgálás folyamatban"
	},
	[Status.DONE]: {
		id: "patient_status.long.done",
		defaultMessage: "Kivizsgálás megtörtént"
	},
	[Status.EXIT]: {
		id: "patient_status.long.exit",
		defaultMessage: "Exit"
	}
});
